module.exports = __webpack_public_path__ + "static/media/ally_pro_web_5.947292c5.jpg";